<template>
  <div class="row">
    <div class="flex xs12">
      <va-card title="精选内容">
        <div class="row align--center mb-1">
          <div class="flex xs12">
            <va-button-group>
              <va-button disabled flat color="gray">职位类型: </va-button>
              <va-button flat :color="postTagId !== null ? 'gray' : 'info'" v-on:click="handlePostTagChange(null)">全部分类 </va-button>
              <va-button
                flat
                :color="postTagId === val.id ? 'info' : 'gray'"
                :key="val.id" v-for="val in postTags"
                v-on:click="handlePostTagChange(val.id)"
              >{{val.name}} </va-button>
            </va-button-group>
          </div>
          <div class="flex md6 xs12 sm6">
            <va-button class="mb-2" flat disabled color="danger">总计{{totalCount}}条结果</va-button>
          </div>
          <div class="flex md6 xs12 sm6">
            <div class="d-flex justify--end">
              <va-button color="info" outline small :to='{name:`savePost`}'>新建面经干货</va-button>
            </div>
          </div>
        </div>
        <va-data-table
          :fields="fields"
          :data="posts"
          :loading="loading"
          :totalPages="totalPages"
          @page-selected="listPost"
          api-mode
        >
          <template slot="sort" slot-scope="props">
            <va-input
              v-model="props.rowData.sortNum"
              type="number"
              :min="1"
            >
              <va-button slot="append" icon="ion-md-checkmark ion" color="info" small @click="updateSortNum(props.rowData)">
              </va-button>
            </va-input>
          </template>
          <template slot="coverUrl" slot-scope="props">
            <img :src="props.rowData.coverUrl" class="data-table-server-pagination---avatar" alt="avatar">
          </template>
          <template slot="type" slot-scope="props">
            <va-badge :color= computeStatus(props.rowData.type).color>
              {{ computeStatus(props.rowData.type).text }}
            </va-badge>
          </template>
          <template slot="backgroundUrl" slot-scope="props">
            <img :src="props.rowData.backgroundUrl" class="data-table-server-pagination---avatar" alt="avatar">
          </template>
          <template slot="actions" slot-scope="props">
            <va-popover message="编辑" placement="top">
              <va-button
                flat
                small
                color="gray"
                icon="fa fa-pencil"
                :to= "{name:'updatePost', params:{ postId: props.rowData.postId}}"
              />
            </va-popover>
            <va-popover message="删除" placement="top">
              <va-button message="删除" placement="top" flat small color="gray" icon="fa fa-trash"
                @click="deleteModal = true;deletePostId=props.rowData.postId"/>
            </va-popover>
          </template>
        </va-data-table>
        <va-modal
          v-model="deleteModal"
          title="删除干货分享成功"
          okText="提交"
          position="center"
          message="请再次确认是否要删除？"
          @ok="confirmDelete"
        />
      </va-card>
    </div>
  </div>
</template>

<script>

import postApi from '@/api/interview/post'
import tagApi from '@/api/tag'
import { TAG_TYPE } from '@/utils/constants'
import { formatTime } from '@/utils/common'
export default {
  data () {
    return {
      message: ['Required field'],
      posts: [],
      loading: true,
      pageNumber: 1,
      pageSize: 10,
      totalPages: 1,
      totalCount: 0,
      postTagId: null,
      postTags: [],
      deletePostId: null,
      deleteModal: false,
    }
  },
  computed: {
    fields () {
      return [
        {
          name: '__slot:sort',
          title: '排序',
          width: '10%',
        },
        {
          name: 'nickname',
          title: '发布人',
          width: '15%',
        },
        {
          name: '__slot:coverUrl',
          width: '60px',
        },
        {
          name: 'title',
          title: '标题',
          width: '25%',
        },
        {
          name: '__slot:type',
          title: '类型',
          width: '10%',
        },
        {
          name: 'createTime',
          title: '发布时间',
          width: '20%',
        },
        {
          name: '__slot:actions',
          width: '12%',
          dataClass: 'text-left',
        },
      ]
    },
  },
  created () {
    this.listPost()
    this.listInterviewTag()
  },
  methods: {
    listPost (pageNumber = this.pageNumber) {
      this.loading = true
      const params = {
        pageNumber: pageNumber,
        pageSize: this.pageSize,
        postTagId: this.postTagId,
      }
      postApi.listPost(params)
        .then(response => {
          console.log(response)
          this.posts = response.posts
          this.posts.forEach(x => {
            x.createTime = formatTime(x.createTime)
          })
          this.pageNumber = pageNumber
          this.totalPages = response.pages.totalPage
          this.totalCount = response.pages.totalCount
          this.loading = false
        })
    },
    listInterviewTag () {
      tagApi.listTag({ tagType: TAG_TYPE.COURSE_TAG.CODE }).then(response => {
        this.postTags = response.tags
      }).catch(error => {
        console.log(error)
      })
    },
    computeStatus: function (type) {
      const data = {
        color: 'success',
        text: '图文',
      }
      if (type === 2) {
        data.color = 'danger'
        data.text = '视频'
      }
      return data
    },
    handlePostTagChange (id) {
      this.postTagId = id
      this.listPost()
    },
    updateSortNum: function (params) {
      const data = {
        sortNum: params.sortNum,
      }
      postApi.updatePostSortNum(params.postId, data).then(response => {
        if (response.success === true) {
          this.showToast('更新排序成功', {
            duration: 1000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
          this.listPost()
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    confirmDelete () {
      if (this.deleteId === null) return
      postApi.deletePost(this.deletePostId).then(response => {
        if (response.success === true) {
          this.showToast('删除干货分享成功', {
            duration: 1000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
          this.listPost()
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
  },
}

</script>

<style lang="scss">
.data-table-server-pagination---avatar {
  width: 60px;
  height: 60px;
  border-radius: 5%;
}
</style>
